import { cn } from '@/lib/cn';

export interface SkeletonProps {
  className?: string;
}

/**
 * Loading placeholder. Prefer a skeleton shaped like the content it replaces
 * over a centred spinner - it keeps the layout from jumping on load.
 */
export function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-pulse rounded-xs bg-surface-muted', className)}
    />
  );
}
